/* eslint-disable */
import requestDev from "@/utils/requestDev";
import { APIReportPHP } from "@/utils/servicesApi";
const qs = require("qs");

export function list(data) {
  return requestDev({
    url: APIReportPHP() + "/store/list",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function deleteData(data) {
  return requestDev({
    url: APIReportPHP() + "/store/delete",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function create(data) {
  return requestDev({
    url: APIReportPHP() + "/store/create",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}
export function update(data) {
  return requestDev({
    url: APIReportPHP() + "/store/update",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}



// WEBPACK FOOTER //
// ./src/api/store.js